import { Text } from "@chakra-ui/react";

import { Info } from "ui/alert";
import { Link } from "ui/link";

export const RowAndColumnOrderingInfo = ({
  variant 
}: { 
  variant: "file" | "spreadsheet" | "message" | "generic" 
}) => {
  const humanReadableVariant = {
    file: "uploaded files",
    spreadsheet: "synced spreadsheets",
    message: "messages",
    generic: "synced data",
  }[variant];
  
  return (
    <Info>
      <Text textStyle="paragraph">
        The order of rows and columns in {humanReadableVariant} may differ from how they appear in your
        model. This is expected behavior and applies to all sync modes.{" "}
        <Link variant="inline" href="/models/creating-models#row-and-column-ordering">
          Learn more about row and column ordering →
        </Link>
      </Text>
    </Info>
  );
};